module.exports = __webpack_public_path__ + "img/Ekko-header-v4@2x.096f2dd6.png";